document.addEventListener('DOMContentLoaded', function () {
    var popupElement = document.querySelector('[data-open-klaviyo-popup]');

    if (popupElement) {
        popupElement.addEventListener('click', function (e) {
            e.preventDefault();
            var klaviyoFormIdHeader = this.dataset.openKlaviyoPopup;
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', klaviyoFormIdHeader]);
        });
    }
});